import * as React from 'react'
import { Tabs } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import ExcelInput, { Props } from './index'
import DownloadLink, { DownloadTemplateTypeEnum } from '../DownloadLink'
import { useFormContext } from '../../context/formContext'
import UpdateLogDrawer from '../ExcelUpdateLog'

const { Pane: TabPane } = Tabs


function ManageExcelAmount (props: Props) {
  const [value, setValue] = React.useState('view')
  const { t } = useTranslation()
  const  { ruleData, effectStatusMap } = useFormContext()
  const onTabClick = (name: string) => {
    setValue(name)
  }

  return (
    <>
      <Tabs
        value={value}
        onTabClick={onTabClick}
        type="line"
        size="small"
      >
        <TabPane
          label={t('e_pc_balance_view', '查看余额')}
          name="view"
        >
          <DownloadLink  templateType={DownloadTemplateTypeEnum.AMOUNT_REST} rulePackId={String(ruleData?.rulePackageId || '')} >{t('e_pc_file_download', '下载文件')}</DownloadLink>
        </TabPane>
        <TabPane
          label={t('e_pc_balance_update', '更新余额')}
          name="update"
        >
          {
            effectStatusMap.isExpired
              ? (<UpdateLogDrawer> <span style={{ color: '#FF5500' }}>{t('e_pc_update_log', '更新记录')}</span> </UpdateLogDrawer>)
              : (<ExcelInput type="update" value={props.value} onChange={props.onChange} rulePackId={String(ruleData?.rulePackageId || '')} />)
          }
        </TabPane>

      </Tabs>
    </>
  )
}

export default ManageExcelAmount